import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd1474de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer no-select" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "infos" }
const _hoisted_4 = { class: "logo" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separate" }, null, -1))
const _hoisted_7 = { class: "menu-media" }
const _hoisted_8 = { class: "menu" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "media" }
const _hoisted_11 = ["src", "alt", "title"]

import { UrlSchema, UrlSocialSchema } from "@/schemas/common/common";
import { getImage, goToLink, getTranslate, checkRouter } from "@/utils";
import { SocialButton } from "@/themes/elements/buttons";
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  props: {
    logo: { default: null },
    logoLocal: { type: Boolean, default: true },
    baseUrl: { default: "#" },
    resume: null,
    font: { default: "Roboto" },
    fontColor: { default: "#fff" },
    menu: null,
    menuColor: { default: "#fff" },
    menuColorHover: { default: "#fff" },
    menuFont: { default: "Roboto" },
    menuFontUppercase: { type: Boolean, default: false },
    social: null,
    socialColor: null,
    socialColorHover: null,
    padding: { default: "3rem" },
    background: { default: "#1a1a1a" },
    separateColor: { default: "#fff" },
    copyrightYear: { default: moment().format("YYYY") },
    copyrightResume: { default: "" },
    copyrightBackground: { default: "#000" },
    copyrightUppercase: { type: Boolean, default: false }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "2e66afe3": (__props.background),
  "1ddde72b": (__props.separateColor),
  "4b05e57c": (__props.padding),
  "a208f202": (__props.fontColor),
  "a078b022": (__props.menuColor),
  "476dce8d": (__props.menuColorHover),
  "84b28d80": (__props.copyrightBackground)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (__props.logo)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(getImage)(__props.logo, __props.logoLocal),
                alt: "logotipo",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goToLink)(__props.baseUrl)))
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(['resume', __props.font])
        }, _toDisplayString(_unref(getTranslate)(__props.resume)), 3)
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menu, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass({
              item: true,
              upper: __props.menuFontUppercase,
              active: _unref(checkRouter)(item.url),
            }),
              onClick: ($event: any) => (_unref(goToLink)(item.url, item.url_external))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(__props.menuFont)
              }, _toDisplayString(_unref(getTranslate)(item.label)), 3)
            ], 10, _hoisted_9))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.social, (item, index) => {
            return (_openBlock(), _createBlock(_unref(SocialButton), {
              key: index,
              url: item.url,
              background: __props.socialColor,
              "background-hover": __props.socialColorHover,
              onTap: ($event: any) => (_unref(goToLink)(item.url, true))
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _unref(getImage)(item.image?.path, item.image?.local),
                  alt: _unref(getTranslate)(item.label),
                  title: _unref(getTranslate)(item.title)
                }, null, 8, _hoisted_11)
              ]),
              _: 2
            }, 1032, ["url", "background", "background-hover", "onTap"]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['copyright', __props.font, __props.copyrightUppercase ? 'upper' : ''])
    }, " ©" + _toDisplayString(__props.copyrightYear) + " " + _toDisplayString(_unref(getTranslate)(__props.copyrightResume)), 3)
  ]))
}
}

})